<div class="entity-name-number-container">
  @if (iconClass) {
    <div>
      <i class="icon {{iconClass}}"></i>
    </div>
  }

  <div class="entity-name-wrapper">
    <div class="name">{{ name }}</div>
    <div class="number">{{ prefix }}{{ numberFormatted ?? '-' }}</div>
  </div>
</div>
